<template>
  <div class="vedio">
    <iframe :src="superior" frameborder="0"></iframe>
  </div>
</template>


<script>
export default {
  data() {
    return {
      superior: ""
    };
  },
  mounted: function() {
    //this.superior = this.$route.query.iframeUrl.split('|')[0]
    // console.log(this.$route.query.iframeUrl);
    
    this.superior = this.$route.query.iframeUrl;
    // this.makeFooter()
  },
  methods: {
    makeFooter() {
      this.axios
        .post("/api/Main/addFootmark", {
          name: "我的信息足迹",
          token: sessionStorage.getItem("token"),
          loginname: this.datas.headline,
          town: window.location.href
        })
        .then(e => {
          console.log(e.data);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.vedio {
  iframe {
    width: 100%;
    height: 100vh;
  }
  padding-top: 1rem;
}
</style>

